import React, { useState } from 'react';
import { Link, useParams } from "react-router-dom";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { useTranslation } from '../contexts/TranslationContext';
import burgerClose from '../images/burgerClose.svg';
import burgerOpen from '../images/burgerOpen.svg';
import sapiooLogo from '../images/sapiooLogo.png';
import ContactLink from "../components/ContactLink";

const Header = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const getMenuClasses = () => {
    return `sm:flex gap-6 sm:gap-4 lg:gap-6 items-center ${
      isMenuOpen ? 'flex flex-col absolute bg-white mt-[86px] z-10 top-[0] w-full h-[100vh] left-0' : 'hidden'
    }`;
  };

  return (
    <header className='p-4 py-6 bg-white fixed w-full top-0 left-0 z-20 border-b'>
      <div className='container m-auto flex items-center justify-between'>
        <Link to={`/${lang}`} className='flex items-center justify-center text-black font-bold text-2xl'>
          <img src={sapiooLogo} alt="Sapioo Logo" className='h-12 object-contain'/>
        </Link>
        <div className='sm:hidden'>
          <button onClick={toggleMenu} className='text-black'>
            <img src={isMenuOpen ? burgerOpen : burgerClose} className={'w-8 h-8'} alt=""/>
          </button>
        </div>
        <div className={getMenuClasses()}>
          <ContactLink styles={'text-black text-base'} text={t('contact')}/>
          <LanguageSwitcher />
          
          <a href={`${process.env.REACT_APP_SAPIOO_PORTAL_HOST}/${lang}`} target={'_blank'} rel="noreferrer" className={'bg-btn-orange p-4 rounded-xl text-white flex justify-center items-center'} style={{width: '177px', height: '56px'}}>
            {t("signIn")}
          </a>       
        </div>
      </div>
    </header>
  );
}

export default Header;